<template>
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.8 0.800781H17.2C18.19 0.800781 19 1.61078 19 2.60078V13.4008C19 14.3908 18.19 15.2008 17.2 15.2008H2.8C1.81 15.2008 1 14.3908 1 13.4008V2.60078C1 1.61078 1.81 0.800781 2.8 0.800781Z"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 2.60156L10 8.90156L1 2.60156"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
